<template>
    <section>
        <m-pane
            ref="orderTablePage"
            v-loading="pageLoading"
            :virtual="true"
            :config="orderConfig"
            :totalData="totalData"
            :loading="orderLoading"
            :configureDefaultHeight="570"
            :moduleCode="visualReportDefId"
            searchId="performance-dispatchDetail-orderTablePageQuery"
            pageID="performance-dispatchDetail-orderTablePage"
            @detail-btn="handleViewItemDetail"
            @searchChange="orderSearchChange"
            class="product-dimension"
        >
        <template v-slot:customTableCell="{ row, col }">
            <div class="table-list-encrypted-panel">
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="点击跳转查看运输单详情"
                    placement="top-start"
                >
                    <el-button type="text" @click="handleJump(row)">{{ row[col.prop] || '--' }}</el-button>
                </el-tooltip>
                <i class="el-icon-document-copy" @click.stop="copyValue(row[col.prop])"></i>
            </div>
        </template>
            <span slot="search-list-advance-last">
                <el-dropdown style="margin-left: 8px">
                    <el-button type="primary">
                        标签<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="handleAddLabel">新建标签</el-dropdown-item>
                        <el-dropdown-item @click.native="handleLabelManage">标签管理</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </span>
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="DISPATCH_DETAIL_ORDER_EXPORT"
                >
                    <el-tooltip effect="dark" content="导出发车单运单明细" placement="bottom">
                        <span class="mgl-10">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                :disabled="!totalData.length"
                                @click="exportOrderFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>

        <!-- 新建标签弹窗 -->
        <add-label-dialog
            v-if="isShowAddLabel"
            ref="addOrderLabel"
            :isShowAddLabel.sync="isShowAddLabel"
            :visualReportDefId="visualReportDefId"
            :columnList="columnList"
        ></add-label-dialog>

        <!-- 标签管理弹窗 -->
        <label-manage-dialog
            v-if="isShowLabelManage"
            ref="labelOrderManage"
            :isShowLabelManage.sync="isShowLabelManage"
            :visualReportDefId="visualReportDefId"
            @handleInitData="handleInitData"
        ></label-manage-dialog>

        <el-dialog
            :title="`商品详情(${taskNo})`"
            :visible.sync="itemDetailDialogVisible"
            width="80%"
            :before-close="handleDetailClose">
            <section class="table-container">
                <el-table
                    border
                    height="250px"
                    style="width:100%"
                    :data="itemList"
                    @cell-dblclick="cellDblClick"
                >
                    <el-table-column
                        v-for="(column, index) in tableProp"
                        :key="index"
                        :width="column.width"
                        :label="column.label"
                        :prop="column.prop"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
            </section>
        </el-dialog>
    </section>
</template>
<script>
import mPane from '@/components/lots/VirtualPanel/index.vue';
import { mapState, mapGetters } from 'vuex';
import { copyToClip } from '../util';
import { orderConfig, tableProp } from './utils.js';
import getList from '@/components/awesome/page/mPanel3/api';
import { queryDetailList } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import reportExport from '@/components/lots/reportExportPlugin';
import AddLabelDialog from '../labelManage/AddLabelDialog';
import LabelManageDialog from '../labelManage/labelManageDialog';
import { getLocal } from '@/utils/storage';
export default {
    name: 'orderTablePage',
    components: {
        mPane, reportExport, AddLabelDialog, LabelManageDialog
    },
    props: {
        totalData: {
            type: Array,
            default () {
                return [];
            }
        },
        pageLoading: {
            type: Boolean,
            default () {
                return false;
            }
        }
    },
    computed: {
        ...mapGetters(['menus']),
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant
        })
    },
    data () {
        return {
            tableProp,
            orderConfig: JSON.parse(JSON.stringify(orderConfig)),
            columnLabels: '',
            searchKey: '',
            searchData: '',
            configurationUrl: '/api-auth',
            visualReportDefId: 'LSP/performance/dispatch-order-detail/taskInfo/order/LSP',
            isShowAddLabel: false,
            isShowLabelManage: false,
            orderLoading: false,
            itemDetailDialogVisible: false,
            taskNo: '',
            itemList: []
        };
    },
    created () {
        this.changeConfig(this.orderConfig.table);
    },
    methods: {
        changeConfig (tableConfig) {
            const initTableLabels = JSON.stringify(tableConfig.columns.filter(v => v.defaultDisplay).map(item => item.label).join(','));
            this.$nextTick(() => {
                const key = `${this.user.employeeId}-columnsConfig-${this.visualReportDefId}`;
                if (!getLocal(key)) {
                    this.handleInitData({ columnList: initTableLabels });
                }
            });
        },
        orderSearchChange (data) {
            const params = {
                dispatchNo: this.$route.query.dispatchNo,
                [data.batchQueryKey]: data.batchQueryValue
            };
            this.searchKey = data.batchQueryKey;
            this.searchData = data.batchQueryValue;
            this.$emit('handleSearchByOrder', params);
        },
        handleJump (row) {
            this.$router.push({
                path: '/performance/waybill-detail',
                query: {
                    dispatchNo: this.$route.query.dispatchNo,
                    id: row.baseTransportId,
                    taskNo: row.taskNo
                }
            });
        },
        handleViewItemDetail (row) {
            this.taskNo = row.taskNo;
            queryDetailList({ taskNo: this.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.itemList = this.formatData(res.data || []);
                    this.itemDetailDialogVisible = true;
                }
            }).catch(() => { });
        },
        /**
         * @description 标签管理
         */
        handleLabelManage () {
            this.isShowLabelManage = true;
        },
        handleAddLabel () {
            this.columnList = JSON.stringify(this.$refs.orderTablePage.tableList);
            this.isShowAddLabel = true;
        },
        async handleInitData (data) {
            if (data.columnList) {
                const columnList = JSON.parse(data.columnList);
                // 表格应用
                this.$refs.orderTablePage.tableList = columnList;
                const configProps = columnList.split(',').map(item => {
                    if (this.orderConfig.table.columns.find(column => column.label === item)) {
                        return this.orderConfig.table.columns.find(column => column.label === item).prop;
                    }
                }).join(',');
                const params = {
                    'configName': configProps,
                    'configNameCn': columnList,
                    'subjectType': 'columnsConfig',
                    'moduleCode': this.visualReportDefId,
                    'id': this.user.employeeId
                };
                const key = `${params.id}-${params.subjectType}-${params.moduleCode}`;
                localStorage.setItem(key, JSON.stringify(params.configNameCn));
                getList.post(this.configurationUrl, params).then(() => { });
            }
        },
        formatData (data) {
            if (!data.length) return [];
            data.forEach(item => {
                Object.keys(item).forEach(key => {
                    item[key] = (item[key] !== null && item[key] !== undefined && item[key] !== '') ? item[key] : '--';
                });
            });
            return data;
        },
        handleDetailClose () {
            this.itemDetailDialogVisible = false;
        },
        exportOrderFile (submit) {
            const exportParams = {
                dispatchNo: this.$route.query.dispatchNo,
                [this.searchKey]: this.searchData,
                tenantCode: this.currentTenant.tenantCode,
                requestResults: this.$refs.orderTablePage.tableList
            };
            submit(exportParams);
        },
        copyValue (value) {
            if (value !== null || value !== undefined || value !== '--') {
                return copyToClip(value);
            }
        },
        /**
         * @description 双击复制单元格信息
         */
        cellDblClick (row, column, cell, event) {
            if (row[column.property] === null || row[column.property] === undefined) return;
            const value = row[column.property];
            copyToClip(value);
        }
    }
};
</script>
<style lang="less" scoped>
.product-dimension {
    .table-list-encrypted-panel {
        /deep/ .el-icon-document-copy {
            font-size: 15px;
            cursor: pointer;
            margin-left: 5px;
            color: #00BCBF;
        }
    }
}
</style>
